import { useState, type ImgHTMLAttributes, type ReactElement } from 'react';
import { resolvePlatformImageResource } from './resolve';

export interface ProductThumbImageProps
  extends Omit<
    ImgHTMLAttributes<HTMLImageElement>,
    'src' | 'onError' | 'className' | 'placeholder'
  > {
  /** 商品原图地址；空值直接渲染 placeholder */
  image?: string | null;
  /** 商品平台（SHOPEE / LAZADA / ...），决定缩略规则 */
  platform?: string | null;
  className?: string;
  /** 无图或缩略/原链也加载失败时的占位；不传则不渲染 */
  placeholder?: ReactElement;
}

/** 商品图统一加载链（对齐 perseus product-thumb-image）：平台缩略地址优先，
 *  加载失败回退原链，原链也失败（或无图）落 placeholder。onError 由组件托管 */
export function ProductThumbImage({
  image,
  platform,
  className,
  placeholder,
  ...imgProps
}: ProductThumbImageProps) {
  const [failedSrc, setFailedSrc] = useState<string>();
  const resource = image ? resolvePlatformImageResource(image, platform) : null;
  const src = !resource
    ? undefined
    : failedSrc === resource.fullSrc
    ? undefined
    : failedSrc === resource.thumbnailSrc
    ? resource.fullSrc
    : resource.thumbnailSrc;
  if (!resource || !src) return placeholder ?? null;
  return (
    <img src={src} alt="" className={className} {...imgProps} onError={() => setFailedSrc(src)} />
  );
}
